import { createButton, createDoor, createLift, type EntityFactory } from '@md/engine';
import { createBolt } from './bolt.js';
import { createElectromagnet } from './electromagnet.js';
import { createPolarizedBlock } from './polarized-block.js';
import { createPolarizedLever } from './polarized-lever.js';

/**
 * Fabriques d'entités du GameModule (spec §4).
 *
 * Les quatre entités génériques du moteur (`button`, `door`, `lift`,
 * `collectible`) sont branchées telles quelles ; `bolt`, `block`,
 * `electromagnet` et `lever` sont propres à Magnetic Duo.
 */
export const ENTITY_FACTORIES: Readonly<Record<string, EntityFactory>> = Object.freeze({
  button: createButton,
  door: createDoor,
  lift: createLift,
  bolt: createBolt,
  block: createPolarizedBlock,
  electromagnet: createElectromagnet,
  lever: createPolarizedLever,
});

export * from './bolt.js';
export * from './electromagnet.js';
export * from './polarized-block.js';
export * from './polarized-lever.js';
export * from './schemas.js';
